import { render } from "./CustomFlowsView.vue?vue&type=template&id=9a024558&scoped=true"
import script from "./CustomFlowsView.vue?vue&type=script&lang=js"
export * from "./CustomFlowsView.vue?vue&type=script&lang=js"

import "./CustomFlowsView.vue?vue&type=style&index=0&id=9a024558&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a024558"]])

export default __exports__